<template>
    <div class="content" ref="content">
        <el-card class="box-card" shadow="never" :style="{minHeight: Height}">
            <el-page-header v-if="back" @back="goBack">
            </el-page-header>
            <div class="page-box" :style="{
                width: !$functions.isPC() ? '100%': '60%',
                minWidth: !$functions.isPC() ? '100%': '900px',
            }">
                <el-descriptions v-if="showGradeBill == 1 && $functions.isPC()"  direction="vertical" :column="4" border>
                    <el-descriptions-item label="昵称">{{data.nickname}}</el-descriptions-item>
                    <el-descriptions-item label="得分">{{data.sumScoreValue}}</el-descriptions-item>
                    <el-descriptions-item label="答对题目">{{data.trueNum}}</el-descriptions-item>
                    <el-descriptions-item label="排名">{{data.ranking}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions v-else-if="showGradeBill == 1 && !$functions.isPC()"  :column="1" >
                    <el-descriptions-item label="昵称">{{data.nickname}}</el-descriptions-item>
                    <el-descriptions-item label="得分">{{data.sumScoreValue}}</el-descriptions-item>
                    <el-descriptions-item label="答对题目">{{data.trueNum}}</el-descriptions-item>
                    <el-descriptions-item label="排名">{{data.ranking}}</el-descriptions-item>
                </el-descriptions>
                <div class="paper-body" :class="{'paper-body-height':showGradeBill != 1}" v-if="findResultParse == 1" v-loading="loading">
                    <AnsweredPreview v-if="examPaperItem.length > 0" :data="examPaperItem"></AnsweredPreview>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import AnsweredPreview from './components/answeredPreview.vue'
import qs from 'qs'
export default {
    beforeRouteEnter(to, from, next){
        next(vm=>{
            if (from.path == '/') {
                vm.back = false
            }
        })
    },
    name: 'UserExamPreview',
    components:{
        AnsweredPreview
    },
    data() {
        return{
            Height: '',
            radioRule: 1,
            examPaperItem: [],
            id: '',
            data: {},
            loading: false,
            back: true
        }
    },
    computed:{
        userId() {
            return this.$route.params.userId
        },
        findResultParse() { // 答案及解析
            return this.$route.params.findResultParse
        },
        showGradeBill() { // 成绩单
            return this.$route.params.showGradeBill
        }
    },
    created() {
        // console.log(sessionStorage.getItem("examId"))
        if(sessionStorage.getItem("examId")){
            this.id = sessionStorage.getItem("examId")
        } else {
            this.id = this.$route.params.id
        }
        this.getData()
        
    },
    mounted() {
        this.Height = `${document.documentElement.clientHeight - 100}px`
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        getData() {
            this.loading = true
            let that = this
            let data = qs.stringify({
                "underwayId": this.userId,
                "surveyId": this.id,
            })
            let params = {
                that: this,
                url: `${this.$config.service.examFindTeacherScore}?${data}`,
                method: "POST",
                cb(res) {
                    that.loading = false
                    // console.log(res)
                    if (res.code == '0'){
                        that.data = res.resultBody
                        if (res.resultBody.teacherAnswerJson.length > 0) {
                            that.examPaper = res.resultBody.teacherAnswerJson
                            
                            that.examPaper.forEach((info) => {
                                that.examPaperItem = [...that.examPaperItem, ...info]
                            })
                        }
                        that.examPaperItem.forEach((info) => {
                            that.$set(info, 'correctAnswer', '')
                            that.$set(info, 'isCorrect', info.isTrue)
                            that.displayLogic(info)
                            if (info.questionsTypeId == 100 
                                || info.questionsTypeId == 102){
                                info.optionList.forEach((item) => {
                                    if (item.oid == info.answer) {
                                        info.correctAnswer = item.labelName
                                    }
                                    if (info.userResult.indexOf(item.oid) !== -1 && info.userResult.indexOf(':') !== -1){
                                        item.inputValue = info.userResult.split(':')[1]
                                    }
                                })
                            } else if(info.questionsTypeId == 101 ){
                                let arr = [],inputValueArr = []
                                info.optionList.forEach((item) => {
                                    if (info.answer.indexOf(item.oid) != -1) {
                                        arr.push(item.labelName)
                                    }
                                    inputValueArr = info.userResult.split(',')
                                    if (inputValueArr.length > 0) {
                                        inputValueArr.forEach((val) => {
                                            if (val.indexOf(item.oid) !== -1 && val.indexOf(':') !== -1){
                                                item.inputValue = val.split(':')[1]
                                            }
                                        })
                                    }
                                })
                                info.correctAnswer = arr.join(',')
                            }else if (info.questionsTypeId == 204 
                                || info.questionsTypeId == 206){
                                info.correctAnswer = info.answer
                            } else if(info.questionsTypeId == 207 || info.questionsTypeId == 208){
                                let arr = [], userResult = []
                                if (info.userResult) {
                                    userResult = JSON.parse(info.userResult)
                                }
                                if (info.optionList && info.optionList.length > 0) {
                                    info.optionList.forEach((val) => {
                                        that.$set(val, 'userResult', '')
                                        arr.push(val.answer)
                                        if(userResult && userResult.length > 0) {
                                            userResult.forEach(j => {
                                                if (val.oid == j.oid) {
                                                    val.userResult = j.value
                                                }
                                            })
                                        }
                                    })
                                    info.correctAnswer = arr.join(',')
                                }
                            }
                        })
                    }
                },
            };
            params.isnologin = true
            this.$util.request(params);
        },
        displayLogic(data) {
			let questionsList = this.examPaperItem;
			for (let j = 0; j < questionsList.length; j++) {
				// 选项关联
				if (data.associated && data.associated.indexOf(questionsList[j].qid) !== -1) {
                    questionsList[j].optionList = [...data.optionList, ...questionsList[j].optionList]
				}
			}
		},
    }
}
</script>

<style scoped lang="scss">
.content{
    // margin:20px 20px 20px 100px;
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background-color: #f1f1f1;
    padding: 20px;
    box-sizing: border-box;
    /deep/.el-card{
        border: none;
        height: inherit;
    }
    .page-box{
        width: 60%;
        min-width: 900px;
        margin: 0 auto;
        margin-top: 30px;
        .paper-body-height{
            max-height: 100vh !important;
        }
        .paper-body{
            
            max-height: calc(100vh - 252px);
            overflow: hidden;
            margin: 30px 0;
            overflow-y: scroll;
            .list{
                // margin-top: 30px;
                background-color: #fcfcfc;
                padding: 30px;
            }
            .user-info{
                margin-left: 30px;
                line-height: 40px;
                .user-info-text{
                    display: inline-block;
                    margin-left: 20px;
                    font-size: 15px;
                }
            }
            .question{
                .top{
                    display: flex;
                    justify-content: space-between;
                    .ques-body{
                        width: 70%;
                    }
                    .title{
                        margin-bottom: 10px;
                    }
                    .option-box{
                        display: flex;
                        flex-wrap: wrap;
                        .option{
                            line-height: 30px;
                            font-size: 14px;
                            .option-index{
                                display: inline-block;
                                width: 25px;
                                height: 25px;
                                line-height: 25px;
                                text-align: center;
                                border-radius: 50%;
                                margin-right: 10px;
                            }
                            .option-action{
                                background-color:rgb(234, 240, 243);
                            }
                        }
                    }
                    .user-answer{
                        background-color: #f5f7f8;
                        font-size: 14px;
                        color: #A2A0A0;
                        padding: 10px;
                        box-sizing: border-box;
                    }
                    /deep/.el-button--primary{
                        border-color: #fff;
                        background-color: #f3f3f3;
                        color:#999;
                    }
                    .result{
                        display: flex;
                        flex-direction: column;
                        .score{
                            font-size: 14px;
                            color: #999999;
                        }
                        .input{
                            margin-top: 20px;
                            width: 70px;
                        }
                    }
                    
                    .correct{
                        background-color: #67C23A;
                        color:#fff;
                    }
                    .error{
                        background-color: #F56C6C;
                        color:#fff;
                    }
                }
                .bottom{
                    margin-top: 30px;
                    .answer{
                        background-color: #f5f7f8;
                        line-height: 36px;
                        font-size: 14px;
                        padding: 0 20px;
                    }
                    .analysis{
                        display: flex;
                        margin-top: 20px;                            
                        background-color: #f5f7f8;
                        line-height: 36px;
                        font-size: 14px;
                        padding: 0 20px;
                        .title{
                            color: #6B828C;
                            display: flex;
                            align-items: flex-start;
                        }
                        .title::before{
                            content: '';
                            margin-right: 5px;
                            display: inline-block;
                            width: 5px;
                            height: 22px;
                            background-color: rgba(188, 208, 217, 1);
                        }
                    }
                }
            }
        }
        .paper-body::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 1px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 10px;
        }
        .paper-body::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px #f1f1f1;
            background: #535353;
        }
        .paper-body::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px #f1f1f1;
            border-radius: 10px;
            background: #ededed;
        }
    }
        
}

</style>